import { alpacaExchangeABI } from '@/utils/abi';
import BigNumber from 'bignumber.js';
import { EventBus } from '@/utils/EventBus';
import { metaMaskErrorHandler, MetaError } from '@/utils/errorHandler';

const contracts: any[] = [null, null, null, null, null, null, null, null];
const contractAddresses = [
  process.env.VUE_APP_ALPACA_EXCHANGE_2000_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_4000_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_10000_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_20000_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_BSC_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_500_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_CHRISTMAS_CONTRACT_ADDRESS,
  process.env.VUE_APP_ALPACA_EXCHANGE_GOLD_CONTRACT_ADDRESS,
];

export const initContract = (pid: number) => {
  if (window.web3 && contracts[pid] === null) {
    contracts[pid] = new window.web3.eth.Contract(alpacaExchangeABI, contractAddresses[pid]);
  }
};

export const initContractBSC = (pid: number) => {
  if (window.web3 && contracts[pid] === null) {
    contracts[pid] = new window.web3.eth.Contract(alpacaExchangeABI, contractAddresses[pid]);
  }
};

export const alpacaCount = async (pid: number) => {
  initContract(pid);
  try {
    const amount = await contracts[pid].methods.alpacaCount().call();
    return amount;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const exchangePrice = async (pid: number) => {
  initContract(pid);
  try {
    const amount = await contracts[pid].methods.exchangePrice().call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const exchangeWoolPrice = async (pid: number) => {
  initContract(pid);
  try {
    const amount = await contracts[pid].methods.exchangeWoolPrice().call();
    return window.web3.utils.fromWei(amount, 'ether');
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const restrictionEndBlock = async (pid: number, address: string) => {
  initContract(pid);
  try {
    const num = await contracts[pid].methods.accountPurchaseRestrictionEndBlock(address).call();
    return num;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const exchange = async (pid: number, eth: BigNumber, count: number, address: string) => {
  initContract(pid);
  try {
    const res = await contracts[pid].methods.exchange(count).send({
      value: window.web3.utils.toWei(`${eth}`, 'ether'),
      from: address,
    }).once('sending', () => {
      EventBus.$emit('trx-result', { status: 'loading', trxId: '' });
    }).once('transactionHash', (hash: string) => {
      EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
    }).on('error', (err: MetaError) => {
      metaMaskErrorHandler(err);
    });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};
